import { Controller } from "@hotwired/stimulus";
import Splide from "@splidejs/splide";

export default class HeroController extends Controller {
  static targets = ["frontSplide", "backSplide"];
  static values = { exactlyOne: Boolean };

  connect() {
    this.initializeSplide();
  }

  disconnect() {
    this.frontSplide?.destroy();
    this.backSplide?.destroy();
  }

  initializeSplide() {
    if (!this.hasBackSplideTarget) return;

    this.backSplide = new Splide(this.backSplideTarget, {
      type: "fade",
      arrows: false,
      pagination: false,
      perPage: 1,
      height: "100%",
      drag: false,
    }).mount();

    this.frontSplide = new Splide(this.frontSplideTarget, {
      type: "loop",
      autoplay: true,
      interval: 7000,
      pauseOnHover: true,
      pauseOnFocus: true,
      perPage: 1,
      destroy: this.exactlyOneValue,
    }).mount();

    this.backSplide.sync(this.frontSplide);
  }
}
